import { createContext, SetStateAction } from "react";

export const WATaskSingleContext = createContext<WATaskSingleContextType>({
  taskId: null,
  storecastId: "",
  setTaskId: (_) => {},
  sectionIds: [],
  setSectionIds: (_) => {},
});

type WATaskSingleContextType = {
  taskId: string | null;
  setTaskId(_: SetStateAction<string | null>): void;
  sectionIds: string[];
  storecastId: string;
  setSectionIds(_: SetStateAction<string[]>): void;
};
